import { createAction, props } from '@ngrx/store';

export const getOperatingAuthorityApplicationData = createAction(
  'get-operating-authority-application',
  props<{ params: any }>(),
);

export const getOperatingAuthorityApplicationDataReceived = createAction(
  'get-operating-authority-application-received',
  props<{ params: any }>(),
);
export const getOperatingAuthorityApplicationDataFailed = createAction(
  'get-operating-authority-application-failed',
);

export const getOperatingAuthorityApplicationFeesData = createAction(
  'get-operating-authority-application-fees',
  props<{ params: any }>(),
);
export const getOperatingAuthorityApplicationFeesDataReceived = createAction(
  'get-operating-authority-application-fees-received',
  props<{ params: any }>(),
);
export const getOperatingAuthorityApplicationFeesDataFailed = createAction(
  'get-operating-authority-application-fees-failed',
);

export const getOperatingAuthorityApplicationInvoicesData = createAction(
  'get-operating-authority-application-invoices',
  props<{ params: any }>(),
);
export const getOperatingAuthorityApplicationInvoicesDataReceived =
  createAction(
    'get-operating-authority-application-invoices-received',
    props<{ params: any }>(),
  );
export const getOperatingAuthorityApplicationInvoicesDataFailed = createAction(
  'get-operating-authority-application-invoices-failed',
);

export const getOperatingAuthorityApplicationDocumentsData = createAction(
  'get-operating-authority-application-documents',
  props<{ params: any }>(),
);
export const getOperatingAuthorityApplicationDocumentsDataReceived =
  createAction(
    'get-operating-authority-application-documents-received',
    props<{ params: any }>(),
  );
export const getOperatingAuthorityApplicationDocumentsDataFailed = createAction(
  'get-operating-authority-application-documents-failed',
);

export const submitPermitRequest = createAction(
  'submit-permit-request',
  props<{ params: any }>(),
);
export const submitPermitRequestReceived = createAction(
  'submit-permit-request-received',
  props<{ params: any }>(),
);
export const submitPermitRequestFailed = createAction(
  'submit-permit-request-failed',
);

export const applyForReinstatement = createAction(
  'apply-for-reinstatement',
  props<{ params: any }>(),
);
export const applyForReinstatementReceived = createAction(
  'apply-for-reinstatement-received',
);
export const applyForReinstatementFailed = createAction(
  'apply-for-reinstatement-failed',
);

export const cancelPermitRequest = createAction(
  'cancel-permit-request',
  props<{ params: any }>(),
);
export const cancelPermitRequestReceived = createAction(
  'cancel-permit-request-received',
);
export const cancelPermitRequestFailed = createAction(
  'cancel-permit-request-failed',
);
